const DEFAULT_RETRIES = 5;
const RETRY_DELAY_MS = 3000;

export const buildRecordingUrl = (template, providerCallId) => {
  if (!template || !providerCallId) {
    return null;
  }
  const encoded = encodeURIComponent(providerCallId);
  return template
    .replace(/\{providerCallId\}/g, encoded)
    .replace(/\{callId\}/g, encoded);
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const fetchGrandstreamRecording = async (config, providerCallId, options = {}) => {
  const url = buildRecordingUrl(config?.recordingFetchUrlTemplate, providerCallId);
  if (!url) {
    return null;
  }

  const username = config?.recordingApiUsername;
  const password = config?.recordingApiPassword;
  const headers = {};
  if (username && password) {
    headers.Authorization = `Basic ${btoa(`${username}:${password}`)}`;
  }

  const maxAttempts = options.maxAttempts ?? DEFAULT_RETRIES;
  const delayMs = options.delayMs ?? RETRY_DELAY_MS;

  for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
    try {
      const response = await fetch(url, { headers, credentials: "omit" });
      if (response.ok) {
        const blob = await response.blob();
        if (blob.size > 0) {
          return blob;
        }
      }
    } catch {
      // UCM recording may not be ready immediately after hangup.
    }
    if (attempt < maxAttempts) {
      await sleep(delayMs);
    }
  }
  return null;
};
